<template>
  <div class="overlay">
   
    <div>
       
      <div>
        <v-card>
         

          <v-form ref="form" v-model="valid" lazy-validation v-if="firstStep || secondStep">
            <v-card width="1000px">
               <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title>
                <div style="display: flex; justify-content: space-between; width: 100%">
                  <span class="text-h5"> Registrar Novo Cliente </span>
                  <div>
                    <v-btn text @click="FecharCard"><v-icon large color="red">clear</v-icon></v-btn>
                  </div>
                </div>
              </v-card-title>


              <v-card-text>
                <v-container>
                  <transition name="slide">
                    <div v-if="firstStep" key="firstStep" class="slide-item">
                      <div style=" display: flex; flex-direction: column; align-items: center;">
                        <div style="display: flex; flex-direction: row; align-items: center;">
                          <div style="width: 300px">
                            <v-text-field ref="biField" required :rules="ruleBI" v-model="editedItem.bi" :label="descricao"></v-text-field>
                          </div>
                          
                        </div>
                        <div style="margin-top: 10px">
                          <v-btn color="primary" :disabled="!valid" @click="checkDocNumber()"> Avançar </v-btn>
                        </div>
                      </div>
                    </div>
                  </transition>

                  <transition name="slide">
                    <div v-if="secondStep" key="secondStep" class="slide-item">
                       <v-container>
                    <v-row dense>
                      <v-col cols="12" sm="6" md="4" class="pa-2">
                        <v-text-field
                          v-model="editedItem.nome"
                          :rules="ruleTextRequired"
                          label="Nome"
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4" class="pa-2">
                        <v-text-field
                          v-if="!editarDados"
                          v-model="editedItem.bi"
                          :disabled="true"
                          :label="descricao"
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4" class="pa-2">
                        <v-combobox
                          v-model="editedItem.pais"
                          :items="pais"
                          item-value="idProvicia"
                          item-text="nome"
                          :rules="ruleRequired"
                          @change="loadProvinciaCombo"
                          @click="loadProvinciaCombo"
                          return-object
                          label="País"
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4" class="pa-2">
                        <v-combobox
                          v-model="editedItem.provincia"
                          :items="provinciasFiltered"
                          item-value="idProvicia"
                          item-text="descricao"
                          :rules="ruleRequired"
                            return-object
                          label="Cidade"
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4" class="pa-2">
                        <v-text-field
                          v-model="editedItem.endereco"
                          label="Endereço"
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4" class="pa-2">
                        <v-text-field
                          v-model="editedItem.telefone"
                          label="Telefone"
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4" class="pa-2">
                        <v-text-field
                          v-model="editedItem.email"
                          :rules="ruleEmailRequired"
                          label="Email"
                          outlined
                          dense
                        />
                      </v-col>
                    </v-row>
                  </v-container>

                    </div>
                  </transition>
                </v-container>
              </v-card-text>
              <v-card-actions v-if="secondStep">
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="voltarParaPrimeiroStep()" :disabled="overlay"> voltar </v-btn>
                <v-btn color="green darken-1" text :disabled="(!valid || overlay)"
                  @click="Guardar()">
                  Guardar </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "@/plugins/axios";
import { mask } from "vue-the-mask";
import utilitarios from "@/plugins/utilitarios";
import Swal from "sweetalert2";
const ls = require("local-storage");
export default {
  directives: { mask },
  name: "NovoEstudante",
  data: () => ({
    result: '',
    mascara: "#########-AA-###",
    editarDados: false,
    overlay: false,
    valid: true,
    ruleTextRequired: [
      (value) => !!value || "campo obrigatório.",
      (value) =>
        (value || "").length <= 70 || "O máximo número de carácters atigidos",
      (value) => (value || "").length > 3 || "carácteres insuficientes",
      (value) => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/;
        return !pattern.test(value) || "Invalido.";
      },
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    ruleBI: [
       
    (value) => !!value || "Campo obrigatório.",
    (value) => value.length === 10 || "O NIF deve ter exatamente 10 dígitos.",
    (value) => /^\d+$/.test(value) || "O NIF deve conter apenas números."

    ],
    editedItem: {
      numeroProcesso: "",
      bi: "",
      pais:"",
      idPessoa: "",
      municipio: null,
      idPerfil: null,
      nome: "",
      morada: "",
      telefone: "",
      autor: "",
      data_: "",
      status_2: "",
      email: "",
      provincia: null,
    },
    descricao: "NIF",
    menubi: false,
    datebi: null,
    menu: false,
    ruleRequired: [(value) => !!value || "campo obrigatorio"],
    provincias: [],
    provinciasFiltered: [],
    municipiosFiltered: [],
    dropdowSexo: [
      { idSexo: "M", descricao: "Masculino" },
      { idSexo: "F", descricao: "Femenino" },
    ],
    cursos: [],
    classesFiltered: [],
    turmasAll: [],
    turmasFiltered: [],
    municipiosAll: [],
    numeroEstudantesCadastrado: [],
    periodos: [
      { id: "M", descricao: "Manhã" },
      { id: "T", descricao: "Tarde" },
      { id: "N", descricao: "Noite" },
    ],
    classes: [],
    defaultItem: {
      pk_estudante: 0,
      numeroProcesso: "",
      pkPessoa: 0,
      classeSelected: "",
      bi: "",
      idPessoa: "",
      municipio: null,
      idPerfil: null,
      nome: "",
      periodo: "",
      morada: "",
      telefone: "",
      autor: "",
      datanascimento: "",
      data_: "",
      status_2: "",
      email: "",
      sexo: "",
      nomedopai: "",
      nomedamae: "",
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: "",
      curso: null,
      turma: null,
      numeroProcesso: "",
      matriculaAntiga: "",
    },
    alert: false,
    iconAlert: "",
    alertType: "",
    colorAlert: "",
    msgAlert: "",
    date: null,
    firstStep: true,
    secondStep: false,
    studenteBi: null,
    existingBi: false,
    estudantesCadastrados: null,
    estatisticas: null,
    blockCadastro: false,
    pais:[],
    aberturaFecho: [],
    d10: true,
    d11: true,
    d12: true,
    d13: true,
    blockCadastroClasse: false
  }),

  computed: {

    instituicaodescricao (){
       return ls.get('instituicaodescricao')
    },

    vagasDisponiveis() {
      return (
        parseInt(
          this.editedItem.turma === null || this.editedItem.turma == undefined ? 0 : this.editedItem.turma.capacidade
        ) -
        parseInt(
          this.numeroEstudantesCadastrado.length ? this.numeroEstudantesCadastrado[0].qtdEstudante : 0
        )
      );
    },

    nivelEnsino() {
      return ls.get("nivel");
    }
  },

  watch: {
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    dialog(val) {
      val || this.close();
    },
  },

  async created() {
    try {
      // Fetch data for estudantesCadastrados and estatisticas
      this.estudantesCadastrados = await axios.get('/estudantesCadastrados').then(res => res.data[0]);
      this.estatisticas = await axios.get('/Config_instituicao_estudantes').then(res => res.data[0]);
      this.aberturaFecho = await axios.get('/listAberturaFechoInstituicao').then((res) => res.data);

      if (this.aberturaFecho.length) {
        const descricoes = ["Inscrições 10", "Inscrições 11", "Inscrições 12", "Inscrições 13"];
        descricoes.forEach((descricao, index) => {
          const filtro = this.aberturaFecho.filter(
            (a) => a.descricao === descricao && a.status_2 == 0
          );
          // Definir a variável correspondente de forma dinâmica
          this[`d${index + 10}`] = filtro.length === 0;
        });
      }

      // Validate `estatisticas` data
      if (this.estatisticas) {
        const hasNullOrEmpty = Object.values(this.estatisticas).some(value => value == null || value == 0);
        if (hasNullOrEmpty) {
          this.FecharCard();
          Swal.fire('Informação', 'Deve configurar as estatísticas do anolectivo actual de todas as classes no sistema!', 'info');
        } else {
          // Initialize other data if all values are valid
          this.initializeData();
        }
      }
    } catch (error) {
      Swal.fire('Erro', 'Falha ao carregar dados das estatísticas.', 'error');
    }
  },



  methods: {
    async initializeData() {
      try {
        this.overlay = true;

        const promises = [
            this.fetchProvincias(),
             this.fetchPais()
          ];

        if (this.nivelEnsino !== 1) {
          promises.push(this.fetchClasses());
        }

        const [provincias, paisesAll] = await Promise.all(promises);

        this.provincias = provincias;
         this.pais = paisesAll
        

      } catch (error) {        
        Swal.fire('Informação', 'Erro ao carregar a página!', 'error')
      } finally {
        this.overlay = false
      }
    },

    async fetchProvincias() {
      try {
        const res = await axios.get("/provinciaFindAll");
        return res.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar as províncias', 'error');
        throw error;
      }
    },

    async fetchMunicipios() {
      try {
        const res = await axios.get("/municipioFindAll");
        return res.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar os municípios!', 'error');
        throw error;
      }
    },

    async fetchPais() {
      try {
        const res = await axios.get("/paisFindAll");
        return res.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar os paises!', 'error');
        throw error;
      }
    },

    async fetchCursos() {
      try {
        const res = await axios.get("/cursoInstituicaoFindAllIntegracao");
        return res.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar os cursos!', 'error');
        throw error;
      }
    },

    async fetchTurmas() {
      try {
        const res = await axios.get("/turmaFindAll/" + this.idclasse);
        return res.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar as turmas!', 'error');
        throw error;
      }
    },

    async fetchClasses() {
      try {
        const res = await axios.get("/classeFindAll2");
        return res.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar as classes!', 'error');
        throw error;
      }
    },


    async checkDocNumber() {
      if (this.editedItem.bi) {
        try {
          let response = await axios.get(`/vericarBIEstudante/${this.editedItem.bi}`).then((res) => res.data);
          if (response.length) {
            this.existingBi = true;
            this.studenteBi = response[0];
          }
          else {
            this.existingBi = false;
          }
    
          this.$refs.biField.validate();
          if (this.existingBi) {
            this.firstStep = false;
            let htmlContent = `
              <p style="text-align: center;"><strong style="color: red;">OBS:</strong> O número de bilhete inserido está 
                sendo usado por outro/a estudante. Verifique novamente o número inserido. Se estiver correto e você 
                continua recebendo este aviso, por favor, entre em contato com os administradores do sistema.</p>
              <div style="width: 90%; margin: 10 auto;">
                <div style="display: grid; grid-template-columns: 150px auto;">
                  <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome do cliente:</strong></div>
                  <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"> ${this.studenteBi.nome}</div>
                </div>
              </div>`;

              Swal.fire('NIF duplicado!', htmlContent, "warning")
              this.FecharCard()
          } else {
            if (this.$refs.form.validate()) {
              this.firstStep = false;
              this.secondStep = true;
            }
          }
        } catch (error) {
          Swal.fire(
            "Informação",
            "Erro ao verificar o número de documento!",
            "error"
          );
        }
      }
    },
    getClasse(idclasse) {
      switch (idclasse) {
        case 1:
          return "10ª classe";
        case 2:
          return "11ª classe";
        case 3:
          return "12ª classe";
        case 4:
          return "13ª classe";
      }
    },

    voltarParaPrimeiroStep() {
      this.secondStep = false;
      this.firstStep = true;
    },
    outroDoc() {
      if (this.descricao === "Outro Doc.") {
        this.editedItem.bi = "";
        this.descricao = "Nº do Bi";
        this.mascara = "#########-AA-###";
        this.ruleBI = [
          (value) =>
            value.length === 16 || "Minimo de caracteres exigido( 16 )",
        ];
      } else {
        this.editedItem.bi = "";
        this.descricao = "Outro Doc.";
        this.mascara = "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX";
        this.ruleBI = [
          (value) =>
            (value.length >= 3 && value.length <= 30) ||
            "Minimo de caracteres exigido( 3 )",
        ];
      }
    },
    saveDatebi(datebi) {
      this.$refs.menubi.save(datebi);
      this.editedItem.dataemissaobi = datebi;
      this.datebi = new Date(datebi).toISOString().substr(0, 10);
    },
    saveDate(date) {
      this.$refs.menu.save(date);
      this.editedItem.datanascimento = date;
      this.date = new Date(date).toISOString().substr(0, 10);
    },

    loadProvinciaCombo ( pais ){
        this.provinciasFiltered = this.provincias.filter(f=>f.fkPais === pais.id) 
    },
     
    loadclasse() {
      /**
       * Nivel Ensino
       * 1 - Superioor
       * 2 - Médio
       */
      if (this.nivelEnsino === 1) {
        for (
          let index = 1;
          index <= parseInt(this.editedItem.curso.numero_anos_academicos);
          index++
        ) {
          this.classesFiltered.push({ id: index, descricao: index + "º ano" });
        }
        this.classesFiltered.push({ id: 100, descricao: "Monografia" });
      } else {
        let classe = 10;
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({
            id: index,
            descricao: classe + "ª Classe",
          });
          classe++;
        }
      }
    },

    returnBloqueado(classe) {
      if (classe == 1) return this.d10;
      else if (classe == 2) return this.d11;
      else if (classe == 3) return this.d12;
      else if (classe == 4) return this.d13;
    },

    loadTurmaComb() {
      this.turmasFiltered = [];
      this.editedItem.turma = null;
      this.editedItem.periodo = null;
      this.turmasFiltered = this.turmasAll.filter(
        (t) =>
          t.idCurso === this.editedItem.curso.idCurso &&
          t.idAno_Academico === this.editedItem.classeSelected.id
      );

      if (this.returnBloqueado(this.editedItem.classeSelected.id)) {
        Swal.fire({
          title: 'Informação',
          text: `O cadastramento para a ${this.getClasse(this.editedItem.classeSelected.id)} está bloqueado!`,
          icon: "warning",
          willOpen: () => {
            document.querySelector('.swal2-container').style.zIndex = 9999;
          }
        });
        this.blockCadastroClasse = true;
      } else {
        this.blockCadastroClasse = false;
        const classeKey = 'classe' + this.editedItem.classeSelected.id;
        this.blockCadastro = Number(this.estudantesCadastrados[classeKey]) >= Number(this.estatisticas[classeKey]);
        if (this.blockCadastro) {
          this.result = `Atingiu o limite de cadastro para a ${this.getClasse(this.editedItem.classeSelected.id)}!`
        }
      }
    },

    async ObterNumeroEstudantesTurma() {
      try {
        this.numeroEstudantesCadastrado = await axios
          .post("ObterNumeroIscritoEstudantesTurma", {
            turma: this.editedItem.turma,
          })
          .then((res) => res.data);

        this.editedItem.periodo = this.periodos.filter((p) => p.descricao === this.editedItem.turma.periodo)[0]
      } catch (error) { }
    },

    FecharCard() {
      this.$emit("fecharComponente", false);
    },
    async Guardar() {
      if (this.$refs.form.validate()) {
        try {
 
          this.overlay = true;

         // await new Promise(resolve => setTimeout(resolve, 20000));


          let params = {
            nome:
              this.editedItem.nome.length <= 0 || this.editedItem.nome === null
                ? this.editedItem.nome
                : utilitarios.SetNameCapitalize(this.editedItem.nome.trim()),
            nif: this.editedItem.bi,
            pais: this.editedItem.pais.id,
            provincia: this.editedItem.provincia.idProvincia,
            autor: ls.get("nomeUsuario"),
            endereco: this.editedItem.endereco,
            email: this.editedItem.email,
            telefone: this.editedItem.telefone,
            instituicaodescricao: this.instituicaodescricao
          };
          
          
 
          let result = await axios.post("clienteInsertOrUpdate", params);

          if (result.data.affectedRows >= 1) {
            Swal.fire(
              "Informação",
              "Cliente cadastrado com sucesso",
              "success"
            );
            this.$emit("fecharComponente", false);
            this.dialog = false;
            this.editedItem = this.defaultItem;
            this.editarDados = false;
          } else if (result.data.status === 1122) {
            // For duplicate entry
            Swal.fire(
              "Informação",
              "<p>NIF já registrado.</p>",
              "warning"
            );
          } else {
            utilitarios.showAlertMessage(
              "error",
              "Ocorreu um erro ao tentar efectuar a operação"
            );
          }
        } catch (error) {
          utilitarios.showAlertMessage(
            "error",
            "Ocorreu um erro ao tentar efectuar a operação"
          );
        } finally {
          this.overlay = false;
        }
      }
    },

    

   async teste(){

         setTimeout(() => {
          
         }, 20000);

   },




    // METHODO FOR VALIDATION
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    close() {
      this.dialog = false;
      this.$refs.form.resetValidation();
    },


    showAlert() {
      this.alert = true;
      this.tab = 0;
      this.colorAlert = "color:green;";
      this.iconAlert = "done";
      this.alertType = "success";
      this.msgAlert = "Actualização efectuada com sucesso!";
      setTimeout(() => {
        this.alert = false;
      }, 4000);
    }
  }
};
</script>

<style scoped>
.boldText {
  font-weight: bolder;
  font-size: 15 px;
}

span {
  margin-right: 10px;
}

.containerTurma {
  text-align: left;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 5px;
  background-color: #fff;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* Distribui o conteúdo ao longo da altura */
}



.margin-card {
  margin-left: 20px;
  margin-bottom: 10px;
}

.tpaCombox {
  height: 50px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 3px;
}

.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 40%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
  max-width: "800px"
}

.slide-item {
  overflow: hidden;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
}

.slide-enter-to,
.slide-leave {
  transform: translateX(0);
}

.alertMessage {
  color: red;
  display: block;
  font-size: 13px;
}
</style>